import apiClient from '../api';

export const registerUser = (data, header) => apiClient.post('/user/register', data, header);
export const loginUser = (data) => apiClient.post('/user/login', data);
export const lostPassword = (data) => apiClient.post('/user/forgot/password', data);
export const resetPassword = (token, data) => apiClient.post(`/user/reset/password/${token}`, data);

export const registerEditor = (data, header) => apiClient.post('/user/editor/register', data, header);